import {
  PatientListActionTypes,
  PATIENT_LIST_FAIL,
  PATIENT_LIST_LOADING,
  PATIENT_LIST_SUCCESS,
  PatientListState,
  PATIENT_LIST_API_MSG,
  PATIENT_LIST_API_RES,
} from "./ActionTypes";
import { PatientDetailsResponse } from "./Model";

const initialStateEditPosts: PatientListState = {
  loading: false,
  PatientListResponse: {} as PatientDetailsResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const patientListReducer = (
  state = initialStateEditPosts,
  action: PatientListActionTypes
): PatientListState => {
  switch (action.type) {
    case PATIENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case PATIENT_LIST_SUCCESS:
      return {
        ...state,
        PatientListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case PATIENT_LIST_FAIL:
      return {
        ...state,
        PatientListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_LIST_API_MSG:
      return {
        ...state,
        PatientListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_LIST_API_RES:
      return {
        ...state,
        PatientListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
